const UPDATES = [
  {
    id: 1,
    date: '2026-07-28',
    title: '《我独自升级》外传正式上线',
    desc: '人气韩漫《我独自升级》番外篇今日在43423漫画网独家上线，采用下拉式阅读模式，带你重回那个热血沸腾的世界。',
    tag: '新作上线',
  },
  {
    id: 2,
    date: '2026-07-25',
    title: '下拉式阅读体验全面升级',
    desc: '平台阅读器优化了预加载算法和夜间模式色彩方案，下拉式漫画的加载速度提升40%，深色阅读更加护眼舒适。',
    tag: '功能更新',
  },
  {
    id: 3,
    date: '2026-07-20',
    title: '韩漫专区新增300+部作品',
    desc: '本月韩漫下拉式资源库大扩充，涵盖恋爱、奇幻、悬疑等多品类，包括多部海外热门作品的官方授权中文版。',
    tag: '资源扩充',
  },
  {
    id: 4,
    date: '2026-07-15',
    title: '「2026夏季漫友推荐」活动开启',
    desc: '社区热门话题板块上线夏季特别活动，分享你最爱的下拉式漫画，赢取专属阅读徽章和限量周边。',
    tag: '社区活动',
  },
  {
    id: 5,
    date: '2026-07-10',
    title: '日漫《咒术回战》最新话同步更新',
    desc: '本周《咒术回战》迎来剧情大转折，下拉式阅读完美呈现高燃战斗场面，单日阅读量突破120万。',
    tag: '热门更新',
  },
  {
    id: 6,
    date: '2026-07-05',
    title: '移动端适配全面优化完成',
    desc: '针对不同屏幕尺寸的下拉式漫画显示效果进行了精细化调整，确保各设备上都能获得最佳阅读体验。',
    tag: '体验优化',
  },
  {
    id: 7,
    date: '2026-07-01',
    title: '43423漫画网上半年阅读报告发布',
    desc: '平台累计下拉式阅读量突破5亿次，「韩漫下拉式」和「日漫下拉式」成为最受欢迎的两大阅读品类。',
    tag: '平台动态',
  },
];

const tagStyles: Record<string, string> = {
  '新作上线': 'bg-accent-100 text-accent-700',
  '功能更新': 'bg-primary-100 text-primary-700',
  '资源扩充': 'bg-secondary-100 text-secondary-700',
  '社区活动': 'bg-accent-100 text-accent-700',
  '热门更新': 'bg-primary-100 text-primary-700',
  '体验优化': 'bg-secondary-100 text-secondary-700',
  '平台动态': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">平台更新与动态快讯</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">随时了解43423漫画网的最新变化与漫画资讯</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {UPDATES.map((update, idx) => (
              <div key={update.id} className={`relative pb-8 md:pb-10 ${idx === UPDATES.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[25px] md:-left-[26px] top-0 w-12 h-12 md:w-[52px] md:h-[52px] rounded-full bg-background-50 border-2 border-background-200 flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-primary-500"></div>
                </div>

                <div className="ml-4 md:ml-6">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500 font-medium">{update.date}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${tagStyles[update.tag] || 'bg-background-200 text-foreground-600'}`}>
                      {update.tag}
                    </span>
                  </div>
                  <h3 className="font-bold text-foreground-950 text-sm md:text-base mb-2">{update.title}</h3>
                  <p className="text-sm text-foreground-700 leading-relaxed">{update.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}